import { FunctionComponent } from 'react';
import { WixChatSmall, VisibleSmall } from '@wix/wix-ui-icons-common';
import { Box, Text } from '@wix/design-system';
import css from './index.module.scss';
import { DATA_HOOKS } from '../../../../../dataHooks';

const Comments: FunctionComponent<{ count: number }> = ({ count }) => (
  <Box gap="3px">
    <WixChatSmall />
    <Text
      dataHook={DATA_HOOKS.SEARCH_RESULT_COMMENTS_NUMBER}
      className={css.number}
      size="tiny"
    >
      {count}
    </Text>
  </Box>
);
const Watch: FunctionComponent<{ count: number }> = ({ count }) => (
  <Box gap="3px">
    <VisibleSmall />
    <Text
      dataHook={DATA_HOOKS.SEARCH_RESULT_WATCH_NUMBER}
      className={css.number}
      size="tiny"
    >
      {count}
    </Text>
  </Box>
);

export const CommentsAndWatch: FunctionComponent<{
  watchCount?: number;
  commentsCount?: number;
}> = ({ watchCount, commentsCount }) => (
  <Box
    dataHook={DATA_HOOKS.SEARCH_RESULT_COMMENTS_WATCH}
    className={css.commentsAndWatch}
    gap="SP1"
  >
    {commentsCount && <Comments count={commentsCount} />}
    {watchCount && <Watch count={watchCount} />}
  </Box>
);
